import React, { Fragment, useRef } from 'react';
import ContactCard from '../../components/ContactCard/ContactCard';
import image from './IMG_20160321_210828.jpg';
import styles from './Contacts.module.css';
import emailjs from '@emailjs/browser';
import { init } from '@emailjs/browser';
init('user_d7xbsvTtlcj84toTdg2j7');

const Contacts = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_e69dos9',
        'template_2sbwypd',
        form.current,
        'user_d7xbsvTtlcj84toTdg2j7'
      )
      .then(
        (result) => {
          console.log(result.text);
          resetForm();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const resetForm = () => {
    var form = document.getElementById('form');
    form.reset();
  };

  return (
    <Fragment>
      <div className={styles.contact}>
        <ContactCard
          name="Ingvar Axelsson, Elektriker"
          email="axelssons.el@gmail.com"
          tel="070333000"
          image={image}
          address="Nyelundsvägen 26
        302 53 Halmstad"
        />
      </div>
      <div className={styles.div}>
        <form
          className={styles.form}
          ref={form}
          id="form"
          onSubmit={sendEmail}
          method="post"
        >
          <h1>Kontakta mig här</h1>
          <br />
          <label>Namn</label>
          <input type="text" name="user_name" />
          <br />
          <br />
          <label>Email </label>
          <br />
          <br />
          <input className={styles.message} type="email" name="user_email" />
          <br />
          <br />
          <label>Meddelande </label>
          <br />
          <br />
          <textarea name="message" />
          <br />
          <br />
          <input className={styles.message} type="submit" value="Send" />
        </form>
      </div>
    </Fragment>
  );
};

export default Contacts;
